// TODO(i18n): Import translation functions from ttag
import React from "react";
import { IStoreSearchFilters } from "tsi-common-react/src/apps/retail/models.interfaces";
import {
    ILocation,
    IRetailStoreWithDistance,
} from "tsi-common-react/src/models/location.interfaces";

import { IFilterChangeHandler } from "../models.interfaces";
import { DistanceFilter } from "./LocatorFilters_Distance";
import { LocationFilter } from "./LocatorFilters_Location";
import { RetailerFilter } from "./LocatorFilters_Retailer";

interface IProps {
    filterValues: IStoreSearchFilters;
    currentLocation: ILocation | null;
    allStores: IRetailStoreWithDistance[];
    filteredStores: IRetailStoreWithDistance[];
    onChange: IFilterChangeHandler;
}

export const LocatorFilters = (props: IProps): React.ReactNode => {
    // TODO(i18n): Use jt to interpolate JSX components into complete sentence. The complete sentence should be translated as one unit with placeholders for count, RetailerFilter, DistanceFilter, and LocationFilter components. Example: jt`${count} results for ${retailerFilter} within ${distanceFilter} of ${locationFilter} that carry Tempur-Pedic products.`
    return (
        <p className="filters__filters">
            <span className="filters__results">
                <strong className="bh-sl-total-results">
                    {props.filteredStores.length}
                </strong>{" "}
                results
            </span>{" "}
            for{" "}
            <RetailerFilter
                filterValues={props.filterValues}
                onChange={props.onChange}
                stores={props.allStores}
            />{" "}
            within{" "}
            <DistanceFilter
                filterValues={props.filterValues}
                onChange={props.onChange}
            />{" "}
            of{" "}
            <LocationFilter
                filterValues={props.filterValues}
                currentLocation={props.currentLocation}
                onChange={props.onChange}
            />{" "}
            that carry Tempur-Pedic products.
        </p>
    );
};
